import createQueryParams from '../Client/createQueryParams';
import { Resource } from '../Resource';
const rootPath = 'radar';
export const fromRaw = ({ radar, forecast }) => {
    const toPastTimestamp = (timestamp) => ({
        originalTimestamp: timestamp,
        isForecast: false
    });
    return {
        forecastTimestampsCreatedAt: forecast.rt[0],
        // Mutation is safe right here, the raw object is not used elsewhere
        // We reverse the ordering of timestamps so that they are ascending and map
        // Everything to an array of RadarTimestamp
        timestamps: radar.map(toPastTimestamp).concat(forecast.t.reduce((acc, timestamp) => {
            // We had false timestamps every 5min so that we have no step differences between past and forecast timestamp
            acc.push({
                originalTimestamp: timestamp,
                isForecast: true,
                createdAt: forecast.rt[0]
            });
            return acc;
        }, []))
    };
};
const radar = Resource((requesterBuilder, { getCtx }) => {
    const host = getCtx().hosts.tiles;
    return {
        getTimestamps: () => requesterBuilder({
            path: `${rootPath}/info`,
            requestCtx: {
                host,
                transform: fromRaw
            },
            config: { staleTime: 1 * 60 * 1000 }
        }),
        // The tile fetching is not handled by us
        getTileUrlTemplate: (query) => `https://${host}/${rootPath}/data${createQueryParams({
            t: query.originalTimestamp,
            rt: query.forecastTimestampsCreatedAt,
            token: query.token
            // This is replaced at runtime, this does not use createQueryParams because it encode URI components
        })}&x={x}&y={y}&z={z}`,
        getSpritesheetTileUrlTemplate: (query) => `https://${host}/${rootPath}/spritesheet${createQueryParams({
            token: query.token,
            x: query.x,
            y: query.y,
            z: query.z,
            ts: query.radarTimestamps.timestamps
                .filter((x) => !x.isForecast)
                .map((x) => x.originalTimestamp),
            fts: query.radarTimestamps.timestamps
                .filter((x) => x.isForecast)
                .map((x) => x.originalTimestamp),
            rt: query.radarTimestamps.forecastTimestampsCreatedAt
        })}`
    };
});
export default radar;
